export const coachKeys = {
  all: ["coach_pro"] as const,
  details: (id: string) => [...coachKeys.all, "details", id] as const,
  professionalUser: () => [...coachKeys.all, "professionalUser"] as const,
}
